import { tolgee } from "@/providers/TranslationProvider";

/**
 * Download a zip file blob.
 * @param zipBlob - The zip blob to download.
 * @param name - The name of the zip file.
 */
export const uploadMultipleFiles = async (zipBlob: Blob, name?: string) => {
  if (!zipBlob) {
    return;
  }

  const zipFileName = `${tolgee.t("zipHDFilesOfOrderItem", {
    mediumName: name,
  })}.zip`;

  const blob = new Blob([zipBlob], { type: "application/zip" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = zipFileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  URL.revokeObjectURL(url);
};
